import { useGetJourneySpecificConfig } from "@hooks/useGetJourneySpecificConfig";

export const useJourneySpecificScrappage = () => {
  const { scrappage } = useGetJourneySpecificConfig();

  return scrappage;
};
